/**
 * NeedLogin
 * 
 * @Author: Focci
 * @Date: 2023-08-18 08:51:50
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-18 08:51:50
 */

'use client'

import AspectRatioCover from '@comp/AspectRatioCover'
import useLogin from '@hook/useLogin'
import { Button, Skeleton } from '@comp/material'
import { useTranslations } from 'next-intl'

import PropTypes from 'prop-types'

export default function NeedLogin({
  title = '',
  meta,
  loading = false
}) {
  const tc = useTranslations('common')
  const { openSigninDialog } = useLogin()

  return (
    <div 
      className="
        border flex items-center justify-between gap-6 p-6
        flex-col md:flex-row
      "
    >
      <div className="w-[5rem] shrink-0 mx-8">
        <AspectRatioCover 
          src="https://s.hougarden.com/file/no/t-/not-signed-in-prompt-icon.png"
          width={100}
          height={91}
          unoptimized
          alt="Need Login"
        />
      </div>
      <div className="flex flex-col items-center gap-1 flex-auto">
        {loading && <Skeleton variant="text" className="text-base font-bold w-1/2" />}
        {!loading && (
          <div className="text-base font-bold whitespace-nowrap">
            {title || tc('needLogin')}
          </div>
        )}
        <div className="w-full">
          {loading ? <Skeleton variant="text" className="w-full" /> : meta}
        </div>
      </div>
      <div className="px-8">
        {!loading && (
          <Button color="error" onClick={openSigninDialog}>
            {tc('loginNow')}
          </Button>
        )}
      </div>
    </div>
  )
}

NeedLogin.propTypes = {
  title: PropTypes.string,
  meta: PropTypes.node,
  loading: PropTypes.bool,
}
